import { put, call, takeEvery } from 'redux-saga/effects';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import {
    crossSaleSearchAPI,
    crossSaleCreateAPI,
    crossSaleDeleteAPI,
} from 'src/api/CrossSaleApi';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { CROSS_SALE_ACTIONS } from '../actions/CrossSaleActions';
import { caseSearchAction } from 'src/containers/case-container/actions/CaseActions';

function* search({
    where,
    currentPage = 0,
    autopopulate = true,
    fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(crossSaleSearchAPI, {
            where: buildSearchWithNoCase({
                where,
                fullTextSearch,
            }),
            sortBy: 'ts',
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: CROSS_SALE_ACTIONS.CROSS_SALE_SEARCH_SUCCESS,
            data: {
                ...data,
            },
            ...where,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));
        return null;
    }
}

function* insert(payload) {
    try {
        yield call(crossSaleCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        }));

        // show message
        yield put(headerShowAction({
            data: 'Cross Sell Added',
        }));

        // refresh
        yield search({
            where: {
                refId: payload.refId,
                source: payload.source,
            },
            fullTextSearch: false,
        });
        //refresh case
        yield put(caseSearchAction({
            where:{_id:payload.refId},
            fullTextSearch: false,
        }))
       
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* remove({
    crossSaleId,
    refId,
    source,
}) {
    try {
        // delete
        yield call(crossSaleDeleteAPI, {
            crossSaleId,
        });

        // show message
        yield put(headerShowAction({
            data: 'Deleted',
        }));

        // refresh
        yield search({
            where: {
                refId,
                source,
            },
        });
       //refresh case
        yield put(caseSearchAction({
            where:{_id:refId},
            fullTextSearch: false,
        }))
    }
    catch (error) {
        console.error('LOG: delete error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

export default [
    takeEvery(CROSS_SALE_ACTIONS.CROSS_SALE_SEARCH, search),
    takeFirstSagaUtil(CROSS_SALE_ACTIONS.CROSS_SALE_INSERT, insert),
    takeFirstSagaUtil(CROSS_SALE_ACTIONS.CROSS_SALE_REMOVE, remove),
];
